var SameSite = /*#__PURE__*/function (SameSite) {
  SameSite["strict"] = "strict";
  SameSite["lax"] = "lax";
  return SameSite;
}(SameSite || {});
function setCookie(key, value, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    domain = _ref.domain,
    expires = _ref.expires,
    _ref$maxAge = _ref.maxAge,
    maxAge = _ref$maxAge === void 0 ? 60 * 60 * 14 * 30 : _ref$maxAge,
    secure = _ref.secure,
    sameSite = _ref.sameSite;
  if (!key) return;
  value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
  key = encodeURIComponent(String(key));
  key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
  key = key.replace(/[()]/g, escape);
  var attrs = [];
  if (path) attrs.push("path=" + path); // path 非常重要, 默认是  location.pathname , 在删除或者修改 cookie 时候, path 没有对齐是无法修改 cookie 的.
  if (domain) attrs.push("domain=" + domain);
  if (expires) attrs.push("expires=" + expires);
  //! important:"max-age" is not supported by IE6/7/8
  if (maxAge) attrs.push("max-age=" + maxAge);
  if (secure) attrs.push('secure');
  if (sameSite) attrs.push("samesite=" + sameSite);
  document.cookie = key + "=" + value + ";" + attrs.join(';');
}

// 为确保获取到相对正确的cookie值，使用domain作为排序的依据
function getCookie(key) {
  var result = '';
  var cookies = document.cookie ? document.cookie.split('; ') : [];
  var REDCode = /(%[0-9A-Z]{2})+/g;
  cookies.sort(function (a) {
    return a.includes("domain=" + window.location.hostname) ? -1 : 0;
  });
  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split('=');
    try {
      var name = parts[0].replace(REDCode, decodeURIComponent);
      if (key === name) {
        result = parts.slice(1).join('=').replace(REDCode, decodeURIComponent);
        break;
      }
    } catch (e) {} // eslint-disable-line
  }

  return result;
}
export { setCookie, getCookie };